<!-- components/GlobalJobSpinner.svelte -->
<script lang="ts">
  import { jobTracker } from "../stores/jobTracker";
  import { slide } from "svelte/transition";

  const { isLoading, lastJobSuccess } = jobTracker;

  let showSuccess = false;
  let wasLoading = false;

  $: {
    if ($isLoading && !wasLoading) {
      // Started loading
      showSuccess = false;
      wasLoading = true;
    } else if (!$isLoading && wasLoading) {
      // Finished loading - show success only if job succeeded
      if ($lastJobSuccess === true) {
        showSuccess = true;
        setTimeout(() => {
          showSuccess = false;
        }, 1500); // Show checkmark for 1.5 seconds
      }
      wasLoading = false;
    }
  }
</script>

{#if $isLoading || showSuccess}
  <div class="job-spinner-container" transition:slide={{ duration: 300, axis: 'x' }}>
    {#if $isLoading}
      <div class="spinner" />
    {:else if showSuccess}
      <div class="checkmark">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20 6L9 17L4 12"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    {/if}
  </div>
{/if}

<style>
  .job-spinner-container {
    position: fixed;
    bottom: 64px; /* Above the menu */
    right: 20px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    padding: 20px;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: pulseContainer 2s ease-in-out infinite;
  }

  @keyframes pulseContainer {
    0%, 100% {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(var(--primary), 0.4);
    }
    50% {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2), 0 0 0 8px rgba(var(--primary), 0);
    }
  }

  :global(.dark) .job-spinner-container {
    background: #27272a; /* zinc-800 */
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  }

  :global(.dark) .job-spinner-container {
    animation: pulseContainerDark 2s ease-in-out infinite;
  }

  @keyframes pulseContainerDark {
    0%, 100% {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5), 0 0 0 0 rgba(var(--primary), 0.4);
    }
    50% {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5), 0 0 0 8px rgba(var(--primary), 0);
    }
  }

  .spinner {
    width: 24px;
    height: 24px;
    border: 3px solid rgba(0, 0, 0, 0.1);
    border-top-color: rgb(var(--primary));
    border-radius: 50%;
    animation: spin 1s linear infinite;
    flex-shrink: 0;
  }

  :global(.dark) .spinner {
    border-color: rgba(255, 255, 255, 0.1);
    border-top-color: rgb(var(--primary));
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .checkmark {
    width: 24px;
    height: 24px;
    color: rgb(var(--primary));
    animation: checkmarkAppear 0.3s ease-out;
  }

  @keyframes checkmarkAppear {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  .checkmark svg {
    width: 100%;
    height: 100%;
  }
</style>
